import {Reducer} from "redux";
import {LOGGED_IN, LOGGED_OUT, LOGIN_FAILED, REFRESH_USER_DATA, SystemActions} from "../store/system-types";
import {User} from "../types/user";

export interface AppState {
    user?: User
    userCheckState: UserCheckState
}

type UserCheckState = 'unchecked' | 'not_logged' | 'logged'

const initialState: AppState = {userCheckState: 'unchecked'}

export const appStateReducer: Reducer<AppState, SystemActions> = (state = initialState, action: SystemActions) => {
    switch (action.type) {
        case LOGGED_IN:
            return {...state, user: action.payload, userCheckState: 'logged'}
        case REFRESH_USER_DATA:
            return {...state, user: action.payload,  userCheckState: 'logged'}
        case LOGGED_OUT:
            return {...state, user: undefined,  userCheckState: 'not_logged'}
        case LOGIN_FAILED:
            return {...state, user: undefined,  userCheckState: 'not_logged'}
        default:
            return state
    }
}